//CRN_20260522 - https://riskline.readme.io/reference/apis-overview

import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ConfigSystemParams, msSize } from 'src/app/core/consts';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

export interface RisklineTripReadyOpenArgs {
  destinationIso: string;
  fromDate      : string;
  originIso     : string;
  toDate        : string;
}

@Component({
  selector   : 'app-riskline-trip-ready-modal-form',
  templateUrl: './riskline-trip-ready-modal-form.component.html',
  styleUrls  : ['./riskline-trip-ready-modal-form.component.scss']
})
export class RisklineTripReadyModalFormComponent implements OnDestroy, OnInit {

  @Input() public defaultDestinationIso: string | undefined;
  @Input() public defaultFromDate      : string | undefined;
  @Input() public defaultOriginIso     : string | undefined;
  @Input() public defaultToDate        : string | undefined;
  @Input() public modalTitle           : string='TripReady';

  @Output() public formCancelled: EventEmitter<void>=new EventEmitter<void>();

  @ViewChild('risklineTripReadyModalForm', { static: false }) public risklineTripReadyModalForm!: TemplateRef<void>;

  private modalRef: NgbModalRef | undefined;

  public destinationIso: string='';
  public fromDate      : string='';
  public originIso     : string='';
  public showPanel     : boolean=false;
  public toDate        : string='';

  get modalBackGround() {
    let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
    return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false);
  }

  constructor(
    private configSystemService: ConfigSystemService,
    private exceptionsService  : ExceptionsService,
    private modalService       : NgbModal
  ) { }

  public ngOnInit(): void {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy(): void {
    try {
      this.modalRef?.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public cancelForm(): void {
    try {
      this.showPanel=false;
      this.formCancelled.emit();
      this.modalRef?.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openForm(args: RisklineTripReadyOpenArgs): void {
    try {
      this.showPanel=false;

      this.destinationIso=args.destinationIso ?? this.defaultDestinationIso ?? '';
      this.fromDate      =args.fromDate       ?? this.defaultFromDate       ?? '';
      this.originIso     =args.originIso      ?? this.defaultOriginIso      ?? '';
      this.toDate        =args.toDate         ?? this.defaultToDate         ?? '';

      this.openModal();

      setTimeout(() => {
        this.showPanel=true;
      });
    }
    catch(e) {
      this.formCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openModal(): void {
    try {
      this.modalRef=this.modalService.open(this.risklineTripReadyModalForm, {
        backdrop   : this.modalBackGround,
        centered   : true,
        keyboard   : false,
        size       : msSize.ExtraLarge,
        windowClass: 'trip-ready-modal'
      });
    }
    catch(e) {
      this.formCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
